<template>
  <section class="pb-32 lg:pb-[133px]">
    <div class="container mx-auto max-w-[800px] px-4">
      <h2
        v-if="title"
        :class="[titleClass || 'text-2xl font-bold', 'mb-6 text-center']"
        v-html="title"
      />
      <h2 v-else class="sr-only">
        <Translate translate-key="faq_section.title" />
      </h2>
      <FaqInner class="mt-10" :faq-type="faqType" />
    </div>
  </section>
</template>
<script setup lang="ts">
import Translate from "~/shared/components/i18n/Translate/Translate.vue";
import FaqInner from "./FaqInner.vue";
import { FAQ_TYPE_CLIENT } from "../constants";

withDefaults(
  defineProps<{
    title?: string;
    titleClass?: string;
    faqType?: number;
  }>(),
  { title: "", titleClass: "", faqType: FAQ_TYPE_CLIENT },
);
</script>
